<section class="intro-options-section dark">
  <div class="content">
    <p class="title">Desarrollarás distintas habilidades</p>
    <div class="description" #animation>
      <p>
        Te prepararemos para ser un desarrollador fullstack en .NET Core y ReactJS. 
        Te especializarás en las tecnologías asociadas de tal manera que tendrás el 
        conocimiento técnico necesario para formar parte de un equipo de desarrollo de software.
      </p>
    </div>
  </div>
</section>
